<script setup lang="ts">
import type { TutorBillingRow } from '../model/interfaces'

import { IndicatorPulse } from '@shared/ui/indicators'

import { useTutorBillingIndicator } from '../model/tutor-billing-indicator.hook'

defineOptions({
  name: 'TutorBillingIndicator',
})

const props = defineProps<{
  row: TutorBillingRow
}>()

const {
  indicator,
  color,
  label,
  setOpen,
} = useTutorBillingIndicator({
  row: computed(() => props.row),
})
</script>

<template>
  <IndicatorPulse
    v-if="indicator"
    :color="color"
    :label="label"
    @click="setOpen"
  />
</template>
